'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { map } from 'rxjs/operators/map';
import Ads from '../models/Ads';
import { Networks } from '../constants/ads';
const API_BASE = 'ads/v1';
const AD_ACCOUNTS_BASE = `${API_BASE}/ad-account`;
export default {
  fetchAdAccountsOverview() {
    return http.get(`${AD_ACCOUNTS_BASE}/overview`);
  },
  fetchAdsData() {
    return forkJoin([this.fetchAdAccountsOverview(), this.fetchMyPermissions()]).pipe(map(([overview, myPermissions]) => Ads.fromJS({
      hasAdwords: overview.accounts.some(account => account.network === Networks.ADWORDS),
      hasAdwordsPermissions: myPermissions.some(permission => permission.adNetwork === Networks.ADWORDS && permission.permissions && permission.permissions.canCreateAds),
      hasAnyAccountConnected: overview.accounts.length > 0,
      hasFacebook: overview.accounts.some(account => account.network === Networks.FACEBOOK),
      hasFacebookPermissions: myPermissions.some(permission => permission.adNetwork === Networks.FACEBOOK && permission.permissions && permission.permissions.canCreateAds),
      hasLinkedIn: overview.accounts.some(account => account.network === Networks.LINKEDIN),
      hasLinkedInPermissions: myPermissions.some(permission => permission.adNetwork === Networks.LINKEDIN && permission.permissions && permission.permissions.canCreateAds)
    })));
  },
  fetchMyPermissions() {
    return http.get(`${AD_ACCOUNTS_BASE}/my-permissions`);
  }
};